module.exports = __webpack_public_path__ + "static/media/home_devises.67c39c39.png";